/* eslint-disable camelcase */
// import { isEmpty } from 'lodash';
import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import { OptionExerciseService, Wealthlane_AwardService_Dtos_OptionExercise_CreateReadyToTransferDto } from '@wealthlane/api-services/wealthlane-award-service';

const usePostOptionExerciseReadyToTransfer = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  setCheckedValues?: any,
  applyConfig?: any,
  selectedTableData?: any,
  isDrsOnly?: boolean
): UseMutationResult<
  Wealthlane_AwardService_Dtos_OptionExercise_CreateReadyToTransferDto,
  unknown,
  any,
  unknown
> => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: any) => {
      const requestBody = {
        exerciseIds: payload,
        intendedShareRegistrationId: applyConfig?.intendedShareRegistrationTypeId,
        transactionAcquisitionTypeId: applyConfig?.transactionAcquisitionTypeId,
        exerciseAllocateTransactionIds:
          selectedTableData
            ?.filter((item: any) => item?.recordTypeSystemName === 'ExerciseAllocate')
            .map((item: any) => item?.transactionId) || [],
      };

      return await handleRequest(
        OptionExerciseService.postApiAwardApiAppOptionExerciseReadyToTransfer(requestBody)
      );
    },
    {
      onSuccess: async (response: any) => {
        if (response != null) {
          const successMessage = isDrsOnly
            ? 'Ready for Registration'
            : 'Sent to Transfer and Allocate';
          toast.success(
            <ToastComponent label='Success' message={successMessage} />
          );
          setCheckedValues([]);
          await queryClient.invalidateQueries('getOptionExercisedList');
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostOptionExerciseReadyToTransfer;
